import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "iodine-scrollable-y search-result" }
const _hoisted_2 = { class: "reference-search-item-icon iodine-padding-right-lg" }

import { GetReferenceBookTermSearchResponse } from 'src/services/TrucodeReferencesService';
import { ref, watch } from 'vue';
import { useTrucodeReferenceStore } from 'stores/TrucodeReferenceStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesSearch',
  emits: ["articleChanged"],
  setup(__props, { emit: __emit }) {

const book = ref('')
const searchText = ref('')
const referenceSearchItems = ref<GetReferenceBookTermSearchResponse | undefined>(undefined)
const emit = __emit
function onSelectionChanged(value: string) {
    emit('articleChanged', value);
}

watch(() => searchText, async (newSearchText) => {
    if (newSearchText && newSearchText.value) {
      await useTrucodeReferenceStore().getReferenceBookTermSearch(book.value, newSearchText.value).then((result) => {
        referenceSearchItems.value = result;
      });
    }
  },
  {immediate: true}
);

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_list, { dense: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(referenceSearchItems.value?.articles || [], (referencesSearchItem) => {
          return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
            key: referencesSearchItem.articleId,
            clickable: "",
            onClick: ($event: any) => (onSelectionChanged(referencesSearchItem.articleId))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_q_icon, {
                  name: "fa-solid fa-circle",
                  size: "10px",
                  color: referencesSearchItem.best ? 'primary' : 'grey'
                }, null, 8, ["color"]),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(referencesSearchItem.best ? 'Best Match' : 'Other'), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createVNode(_component_q_item_section, { class: "search-result-item" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(referencesSearchItem.articleTitle) + " ", 1),
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(referencesSearchItem.articleTitle), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["onClick"])), [
            [_directive_ripple]
          ])
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})